import { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "@/lib/i18n/init";

interface I18nProviderProps {
  children: React.ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkAndSetReady = () => {
      if (i18n.isInitialized && i18n.hasLoadedNamespace("translation")) {
        setIsReady(true);
        return true;
      }
      return false;
    };

    // Check immediately
    if (checkAndSetReady()) {
      return;
    }

    // If not ready, set up listeners
    const handleLoaded = () => {
      if (checkAndSetReady()) {
        i18n.off("loaded", handleLoaded);
        i18n.off("languageChanged", handleLoaded);
      }
    };

    i18n.on("loaded", handleLoaded);
    i18n.on("languageChanged", handleLoaded);

    // Cleanup listeners
    return () => {
      i18n.off("loaded", handleLoaded);
      i18n.off("languageChanged", handleLoaded);
    };
  }, []);

  // Don't render children until translations are ready
  if (!isReady) {
    return null;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
